import React, { FC } from "react";

import { TeamContextProvider } from "./TeamContext";
import { UserContextProvider } from "./UserContext";
import { FabricContextProvider } from "./FabricContext";
import { BoardContextProvider } from "./BoardContext";
import { TableContextProvider } from "./TableContext";
import { SocketContextProvider } from "./SocketContext";
import { PhaseContextProvider } from "./PhaseContext";
import { CardContextProvider } from "./CardContext";
import { SlotMachineContextProvider } from "./SlotMachineContext";


interface GlobalContextProps {
  children: React.ReactNode;
}

const GlobalContextProvider: FC<GlobalContextProps> = (props) => {
  return (
    <SocketContextProvider>
      <TeamContextProvider>
        <UserContextProvider>
          <FabricContextProvider>
            <PhaseContextProvider>
              <SlotMachineContextProvider>
                <BoardContextProvider>
                  <TableContextProvider>
                    <CardContextProvider>
                      {props.children}
                    </CardContextProvider>
                  </TableContextProvider>
                </BoardContextProvider>
              </SlotMachineContextProvider>
            </PhaseContextProvider>
          </FabricContextProvider>
        </UserContextProvider>
      </TeamContextProvider>
    </SocketContextProvider>
  );
};

export default GlobalContextProvider;
